import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { SpinnerPage, CheckboxInline } from '@common/components';
import { ContractHostedPayment } from 'src/contract/_components/contract-payment/_components/contract-payment-hosted-container';
import {
  CreditCardPaymentViewModel,
  PaymentTerms,
  PaymentType,
  PaymentPurpose,
  ContractPaymentDetailViewModel,
  CreditCardChargeViewModel
} from '@models/Payment';
import { HostedCheckout } from 'src/payment/_components/gateway/hosted-checkout-container';
import { PaymentMethods } from '@models/HostedCheckoutTransactionViewModel';
import Constants from '@constants/Constants';
import { Control } from 'react-redux-form';
import { history } from 'src';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { dateParser } from '@common/dateParser';
import { ContractOrderType } from '@models/Contract';

export interface PaymentEditProperties extends RouteComponentProps<{ id: number }> {
  readonly loading: boolean;
  readonly totalPrice: number;
  readonly orderType: ContractOrderType;
  readonly contractPaymentDetail: ContractPaymentDetailViewModel;

  readonly initializePaymentEdit: (id: number) => void;
  readonly openCreditCardModal: (
    contractId: number,
    creditCard?: CreditCardPaymentViewModel,
    hostedCheckoutButton?: HTMLButtonElement | null
  ) => void;
  readonly convertToDemandLetter: (contractId: number) => void;
}

interface PaymentEditState {
  paymentType: PaymentType;
}

export class PaymentEditComponent extends React.Component<PaymentEditProperties, PaymentEditState> {
  launchButton: HTMLButtonElement | null = null;

  constructor(props: PaymentEditProperties) {
    super(props);

    this.state = {
      paymentType: PaymentType.None
    };
  }

  componentWillMount() {
    if (this.props.match && this.props.match.params.id) {
      this.props.initializePaymentEdit(this.props.match.params.id);
    }
  }

  handleConvertToDemandLetter = () => {
    this.props.convertToDemandLetter(this.props.match.params.id);
  };

  renderCreditCardInfo = () => {
    const cpDetail = this.props.contractPaymentDetail;
    return cpDetail ? (
      <label>
        {'Change card for upcoming installments and apply new calculated amounts'}
        <button
          className={'btn btn-primary'}
          key={cpDetail.creditCardPayment.token}
          onClick={() =>
            this.props.openCreditCardModal(this.props.match.params.id, cpDetail.creditCardPayment, this.launchButton)
          }
          hidden={
            cpDetail.enableDemandLetter &&
            this.props.orderType === ContractOrderType.RealtyEscrow &&
            this.state.paymentType !== PaymentType.CreditCard
          }
        >
          Update
        </button>
      </label>
    ) : (
      ''
    );
  };

  render() {
    if (this.props.loading) {
      return <SpinnerPage />;
    }
    const cpDetail = this.props.contractPaymentDetail;
    return cpDetail ? (
      <>
        <h2>Payment Edit</h2>
        {cpDetail.paymentBalance > 0 ? (
          <>
            {/* <div className="row">
              <div className="col-xs-12">
                <h3>Order Type: {this.props.orderType}</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <h3>Payment Balance = ${cpeInfo.paymentBalance.toFixed(2)}</h3>
              </div>
            </div> */}
            {cpDetail.creditCardPayment ? (
              <>
                <div className="row">
                  <div className="col-xs-12">
                    <h3>Upcoming Installments</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-4">
                    <h3>Charge Date</h3>
                  </div>
                  <div className="col-xs-4">
                    <h3>Charge Amount</h3>
                  </div>
                  <div className="col-xs-4">
                    <h3>New Calculated Amount</h3>
                  </div>
                </div>
                {cpDetail.creditCardCharges &&
                  cpDetail.creditCardCharges.map((value: CreditCardChargeViewModel, index: number) => {
                    return (
                      <div className="row" key={value.chargeId}>
                        <div className="col-xs-4">
                          <h4>{dateParser.parse(value.chargeDate!).format('MM/DD/YYYY')}</h4>
                        </div>
                        <div className="col-xs-4">
                          <h4>${value.chargeAmount.toFixed(2)}</h4>
                        </div>
                        <div className="col-xs-4">
                          <h4>${value.calculatedAmount.toFixed(2)}</h4>
                        </div>
                      </div>
                    );
                  })}
                <div className="row">
                  <div className="col-xs-12">
                    <h3>
                      {'Current Credit Card for Upcoming Installments: ' +
                        cpDetail.creditCardPayment.creditCardType +
                        ' xxxxxxxx' +
                        cpDetail.creditCardPayment.number}
                    </h3>
                  </div>
                </div>
                <div className="row">
                  <HostedCheckout
                    contractId={this.props.match.params.id}
                    getHiddenFormButton={b => (this.launchButton = b)}
                    paymentMethod={PaymentMethods.CreditCard}
                    installmentsFee={Constants.Payments.INSTALLMENT_SERVICE_FEE}
                    paymentAmountInitial={0}
                    paymentAmountBalance={0}
                    paymentTerms={PaymentTerms.OneInstallment}
                    paymentTypeInitial={PaymentType.CreditCard}
                    paymentTypeBalance={PaymentType.CreditCard}
                    paymentPurpose={PaymentPurpose.PreAuthorization}
                    remainingBalance={0}
                    remainingBalanceDueString="0"
                  />
                  <div className="col-md-12">
                    {cpDetail.enableDemandLetter ? (
                      <CheckboxInline>
                        <Control
                          checked={this.state.paymentType === PaymentType.CreditCard}
                          id="creditCardPayment"
                          model="futurePayments"
                          name="futurePayments"
                          onChange={e => this.setState({ paymentType: PaymentType.CreditCard })}
                          value={PaymentType.CreditCard}
                          type="radio"
                        />
                        {this.renderCreditCardInfo()}
                      </CheckboxInline>
                    ) : (
                      this.renderCreditCardInfo()
                    )}
                  </div>
                </div>
                {cpDetail.enableDemandLetter &&
                  this.props.orderType === ContractOrderType.RealtyEscrow && (
                    <div className="row">
                      <div className="col-md-12">
                        <CheckboxInline>
                          <Control
                            checked={this.state.paymentType === PaymentType.DemandLetter}
                            id="demandLetter"
                            model="futurePayments"
                            name="futurePayments"
                            onChange={e => this.setState({ paymentType: PaymentType.DemandLetter })}
                            value={PaymentType.DemandLetter}
                            type="radio"
                          />
                          <label>
                            {'Remove upcoming installments and send Demand Letter for balance'}
                            <button
                              className="btn btn-primary"
                              hidden={this.state.paymentType !== PaymentType.DemandLetter}
                              onClick={this.handleConvertToDemandLetter}
                            >
                              Send
                            </button>
                          </label>
                        </CheckboxInline>
                      </div>
                    </div>
                  )}
              </>
            ) : (
              <>
                <ContractHostedPayment
                  {...this.props}
                  isRenewal={false}
                  buttonRef={b => (this.launchButton = b)}
                  hideStepLabel={true}
                  contractId={this.props.match.params.id}
                />
                <div className="row end-xs">
                  <div className="col-xs-10">
                    <div className="row">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          history.push(
                            this.props.match && this.props.match.params.id
                              ? getRoute(RouteDefinitions.contract.Details, {
                                  id: +this.props.match.params.id
                                })
                              : RouteDefinitions.dashboard
                          );
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                  <div className="col-xs-2">
                    <div className="row end-xs">
                      <button
                        className="btn btn-primary"
                        onClick={() =>
                          this.props.openCreditCardModal(this.props.match.params.id, undefined, this.launchButton)
                        }
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <h3>No contract balance due at this time.</h3>
            <div className="row">
              <div className="col-xs-12">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    history.push(
                      this.props.match && this.props.match.params.id
                        ? getRoute(RouteDefinitions.contract.Details, {
                            id: +this.props.match.params.id
                          })
                        : RouteDefinitions.dashboard
                    );
                  }}
                >
                  View Contract Details
                </button>
              </div>
            </div>
          </>
        )}
      </>
    ) : (
      <h1>No Payment Edit Info</h1>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/payment-edit/_components/payment-edit.component.tsx